import ApplicationAdapter from './application';
import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';

type AdapterPayload = ReturnType<ApplicationAdapter['queryRecord']>;

/**
 * custom adapter for wellness train model
 *
 * @memberof adapters
 */
export default class WellnessTrainAdapter extends ApplicationAdapter {
  // there's not an API resource for this data; it actually comes from the user profile route
  // subordinate to the user show resource with a profile_key param of
  // UserProfileAttribute.WELLNESS_TRAIN
  async queryRecord(
    _store: Store,
    _type: ModelSchema<unknown>,
    query: Record<string, unknown>
  ): AdapterPayload {
    const { userId } = query;

    // concatting a forward slash onto the end of the JSONAPIAdapter.buildURL method in order to
    // properly set the current directory for URL constructor; see docs at here:
    // https://developer.mozilla.org/en-US/docs/Web/API/URL_API/Resolving_relative_references
    // @ts-expect-error: As we replace with request manager these will be resolved
    const resourceUrl = this.buildURL('user', userId).concat('/');
    const url = new URL('user-profile', resourceUrl);
    url.searchParams.append('profile_key', 'UserProfileAttribute.WELLNESS_TRAIN');

    const payload = await this.ajax(url.toString(), 'GET');

    return { ...payload, userId };
  }

  // NB: should this class implement all the other built-in methods and throw specific errors?
  //     that feels expressive but will anyone ever try to call those? this whole thing probably
  //     could have been modeled better tbh - james 20250726
}
